<template>
  <div class="modal-toast">
    <div class="line" :class="[param.type]"></div>
    <div class="content" v-html="param.content"></div>
    <div class="button-row">
      <button v-for="(button, index) in param.buttons || []" :key="index" class="long-button" :class="[button.type + '-button']" @click="$emit('changeModal', {}, button.result)">
        <span>{{ button.title }}</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/toast.vue